// extracted by mini-css-extract-plugin
export default {"images":"UserAdvertDetailsModal_images__r4-1T","images__item":"UserAdvertDetailsModal_images__item__cNw-F","spin":"UserAdvertDetailsModal_spin__Hlwou"};